<div class="form-row row w-100 m-0 p-0 mt-2">
    
    <div class="col-6 m-0 p-0">
        <div class="row m-0 p-0 w-100">

            <div class="col-auto pl-1 pr-1 m-0">
                <mat-form-field appearance="fill" *ngIf="mfgs">
                    <mat-label>Brand</mat-label>
                    <mat-select [formControl]="mfgRef" multiple appSelectAll>
                        <mat-option *ngFor="let i of mfgs" [value]="i.value">
                            {{i.view}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
          
            <div class="col-auto pl-1 pr-1 m-0">
                <mat-form-field appearance="fill" *ngIf="productlines">
                    <mat-label>Product Lines</mat-label>
                    <mat-select [formControl]="productlineRef" multiple appSelectAll>
                        <mat-option *ngFor="let i of productlines" [value]="i.value">
                            {{i.view}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-auto pl-1 pr-1 m-0">
                <mat-form-field appearance="fill" *ngIf="categories">
                    <mat-label>Category</mat-label>
                    <mat-select [formControl]="categoryRef" multiple appSelectAll>
                        <mat-option *ngFor="let i of categories" [value]="i.value">
                            {{i.view}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-auto pl-1 pr-1 m-0">
                <button class="id-scale" mat-mini-fab color="accent" (click)="resetFilters()" [disabled]="!categoryRef.value.length && !mfgRef.value.length && !productlineRef.value.length"><mat-icon>clear_all</mat-icon></button>
            </div>

        </div>
    </div>


    <div class="col-6 m-0 p-0">
        <div class="row p-0 m-0 w-100">
            <div class="col-10 pl-1 pr-1">
                <mat-form-field appearance="outline" class="searchbar">
                    <input matInput [formControl]="searchRef" #itemrec id="itemrec" value="" class="margin-top" autocomplete="off" placeholder="* Item Search  ">
                    <div matSuffix class="text-right">
                        <button mat-icon-button type="button" color="white" (click)="$event.stopPropagation();$event.preventDefault();filterItems()">
                            <mat-icon>search</mat-icon>
                        </button>
                    </div>
                </mat-form-field>
            </div>
            <div class="col-2 pl-1 pr-1">
                <div class="font-weight-lighter"><mat-slide-toggle  (change)="toggleDiscontinued()" ([value])="discontinuedRef.value"></mat-slide-toggle>&nbsp;Discontinued?</div>
                <div class="font-weight-lighter"><mat-slide-toggle  (change)="filterItems()" [formControl]="hasimageRef"></mat-slide-toggle>&nbsp;Missing only?</div>
            </div>
        </div>  
    </div>
</div>


<hr class="w-100 p-0 m-0"/>
<button style="opacity: 0; height: 0px; position:absolute; z-index: -2" id="blur"></button>
<div class="row d-flex justify-content-between">
    <div class="column">
        <div class="font-weight-lighter desc-scale" *ngIf="active" [ngClass]="{'novis': firstaction}">Left & Right arrows on the keyboard control active selection</div>
        <div class="font-weight-lighter desc-scale" *ngIf="active">Index: {{active.index + 1}}</div>
    </div>
    <mat-paginator [ngClass]="{'d-none': !items_freeze.length}" [pageSizeOptions]="items_per_page" [pageSize]="pagesizedefault" showFirstLastButtons (page)="blur()"></mat-paginator>
</div>
<div class="row m-0 p-0 w-100 mh-650">
    <div class="col-8 m-0 p-0">

        <svg *ngIf="itemsloading" class="spinner m-auto d-block mt-2" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
        </svg>
       
        <table class="table-fixed table-bordered table-sticky" *ngIf="!itemsloading">
            <thead class="th-bg">
                <th> <mat-icon class="image-indicator th-camera">camera</mat-icon> </th>
                <th>Stock ID</th>
                <th>Brand<mat-icon matTooltip="Double clicking a brand cell will add / remove it as a filter" class="info-tool">help</mat-icon></th>
                <th>Product Line<mat-icon matTooltip="Double clicking a product line cell will add / remove it as a filter" class="info-tool">help</mat-icon></th>
                <th>Category<mat-icon matTooltip="Double clicking a category cell will add / remove it as a filter" class="info-tool">help</mat-icon></th>
                <th>Discontinued</th>
            </thead>
            <tbody>
                <tr *ngFor="let row of dataObs | async; let i = index" [ngClass]="{'viewing-row': row.active}" (click)="setActive(row)">
                    <td class="indicator-td" [ngClass]="{'indicator-bad': !row.image, 'indicator-good': row.image}">
                        <mat-icon class="image-indicator" [ngClass]="{'text-danger': !row.image, 'text-success': row.image}">
                            <ng-container *ngIf="row.image">image</ng-container>
                            <ng-container *ngIf="!row.image">broken_image</ng-container>
                        </mat-icon>
                    </td>
                    <td>
                        <div class="w-100 desc-row m-0 p-0">
                            <b>{{row.stockid}}</b>
                            &nbsp;&nbsp;&nbsp;
                            <span class="font-weight-lighter desc-scale">{{row.description}}</span>
                        </div>
                    </td>
                    <td [ngClass]="{'cursor-remove row-filtered': mfgRef.value.includes(row.manufacturer_id), 'cursor': !mfgRef.value.includes(row.manufactuer_id)}" (dblclick)="updateMfgFilter(row.manufacturer_id)">{{row.name}}</td>
                    <td class='td-container' [ngClass]="{'cursor-remove row-filtered': productlineRef.value.includes(row.lineid), 'cursor': !productlineRef.value.includes(row.lineid)}" [matToolTip]="productlinenames[row.lineid]" (dblclick)="updateProdlineFilter(row.lineid)">
                        {{productlinenames[row.lineid]}}
                        <span class="id-scale">&nbsp;{{row.lineid}}</span>
                    </td>
                    <td (dblclick)="updateCategoryFilter(row.categoryid)" [ngClass]="{'cursor-remove row-filtered': categoryRef.value.includes(row.categoryid), 'cursor': !categoryRef.value.includes(row.categoryid)}">
                        {{categorynames[row.categoryid]}}
                        <span class="id-scale">&nbsp;{{row.categoryid}}</span>
                    </td>
                    <td class="text-center">
                        <ng-container *ngIf="row.discontinued == 1">
                            <b>Yes</b>
                        </ng-container>
                        <ng-container *ngIf="row.discontinued == 0">
                            <span class="font-weight-lighter">No</span>
                        </ng-container>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="col-4 m-0 p-2">
        <div class="sticky-top">
            <div class="card p-1 m-0" *ngIf="active?.stockid?.length">
                <div class="card-header card-header-{{config.color ?? 'blue'}}-5">
                    <h5 class="m-0 p-0">{{active.stockid}} <span class="font-weight-lighter desc-scale m-0 p-0">{{active.description}}</span></h5>
                    <br class="m-0 mb-2 p-0 d-block w-100" />
                    <div class="row d-flex justify-content-around font-weight-lighter m-0 p-0 extra-active-container">
                        <h6 class="m-0 p-0">BRND: <b>{{mfgnames[active.manufacturer_id]}}</b></h6>
                        <h6 class="m-0 p-0">PRD: <b>{{productlinenames[active.lineid]}}</b></h6>
                        <h6 class="m-0 p-0">CAT: <b>{{categorynames[active.categoryid]}}</b></h6>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row text-center w-100 ml-auto mr-auto mb-2" *ngIf="(active.editingimages || active.image == '' ) && !active.dummy">
                        <ngx-dropzone class="w-100 dropzone" [multiple]="false" (change)="onSelect($event)">
                            <ngx-dropzone-label>
                                <div class="col-12 ml-auto mr-auto text-center w-100">
                                    DROP FILE HERE OR CLICK TO UPLOAD
                                </div>
                            </ngx-dropzone-label>
                            <ngx-dropzone-preview  *ngFor="let f of files" [removable]="true" (removed)="onRemove(f)" (error)="onUploadError($event)" (success)="onUploadSuccess($event)">
                                <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                            </ngx-dropzone-preview>
                        </ngx-dropzone>
                    </div>
                    
                    <div class="product-gallery" *ngIf="!active.dummy || active.image == ''">
                        <div class="main-image-container zoom-main-image">
                            <div class="image-wrapper">
                                <button mat-mini-fab class="d-none btn-delete" (click)="removeMainImage()">
                                    <mat-icon>delete</mat-icon>
                                    <mat-label class="d-none delete-text">Remove image?</mat-label>
                                </button>
                                <mat-icon class="d-none btn-edit">edit</mat-icon>
                                <img [src]="active.image" class="img img-fluid img-responsive thumbnail item-image zoom-main-img mx-auto d-block" (click)="active.editingimages = !active.editingimages"/>
                                <span class="add-img-label d-none">Primary Image - Click to add additional</span>
                            </div>
                        </div>
                        <mat-label *ngIf="active.images && active.images.length > 1" class="additional-label">Additional images - <span class="font-weight-lighter">click to select main image</span></mat-label>
                        <div class="thumbnail-container" *ngIf="active.images && active.images.length > 1">
                            <ng-container *ngFor="let thu of active.images">
                                <div class="thumbnail zoom-thumb" (click)="changeMainImage(thu)">
                                    <div class="main-image-container">
                                        <div class="image-wrapper">
                                            <img [src]="thu.thumb" [alt]="thu.alt" class="zoom-thumb-img">
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>









